<template>
  <div class="project-info-fields">
    <el-form-item
      v-if="showProjectSource"
      label="项目来源"
      prop="projectSource"
    >
      <div style="display: flex; align-items: center; gap: 10px;">
        <el-select
          v-model="form.projectSource"
          placeholder="请选择项目来源"
          @change="handleProjectSourceChange"
          style="width: 200px;"
        >
          <el-option label="招采进宝平台" value="1"></el-option>
          <el-option
            v-for="item in otherPlatformOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
          <el-option label="其他" value="2"></el-option>
        </el-select>
        <el-select
          v-if="form.projectSource === '1'"
          v-model="form.sourceRadio"
          placeholder="请选择项目地区"
          @change="handleSourceRadioChange"
          style="width: 150px;"
        >
          <el-option
            v-for="item in zbjOtherOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
          <el-option v-if="showXt" label="邢台地区" value="0"></el-option>
        </el-select>
      </div>
      <div style="color: #999; font-size: 12px; margin-top: 5px; line-height: 1.6;">
        请确认您的项目来源，选择错误可能会导致保函无法正确推送到项目交易平台；</br>线下项目或查找不到对应交易平台的请选择"其他"；
      </div>
    </el-form-item>

    <el-form-item :label="resolvedLabelProjectName" prop="projectName">
      <el-input
        v-if="(!showProjectSource && !isBsgzw) || form.projectSource === '2'"
        v-model="form.projectName"
        :placeholder="isCqsw ? '请填写真实项目名称' : '请填写真实项目名称或标段（包）名称'"
        :disabled="isNameDisabled"
      />
      <div v-else>
        <div v-if="!isSelfFill">
          <el-input
            v-if="showXt && form.projectSource === '1' && form.sourceRadio === '0'"
            v-model="form.projectName"
            :disabled="true"
            placeholder="点击查询邢台交易中心项目"
          >
            <el-button
              slot="append"
              type="primary"
              icon="el-icon-search"
              @click="onSearchXt"
            >搜索</el-button>
          </el-input>
          <el-input
            v-else
            v-model="form.projectName"
            :disabled="true"
            placeholder="点击查询项目"
            style="flex: 1;"
          >
            <el-button
              slot="append"
              type="primary"
              icon="el-icon-search"
              @click="onSearchStandard"
            >搜索</el-button>
          </el-input>
          <el-button type="text" style="position: absolute; right: -130px; top: 0; white-space: nowrap;" @click="handleSelfFill">自行填写标段信息</el-button>
        </div>
        <div v-else>
          <el-input
            v-model="form.projectName"
            placeholder="请填写真实项目名称或标段（包）名称"
            style="flex: 1;"
          />
          <el-button type="text" style="position: absolute; right: -100px; top: 0; white-space: nowrap;" @click="handleSearchProject">搜索项目信息</el-button>
        </div>
      </div>
    </el-form-item>

    <el-form-item :label="resolvedLabelProjectCode" prop="projectCode">
      <el-input
        v-model="form.projectCode"
        :placeholder="isCqsw ? '请填写真实项目编号' : '请填写真实项目编号或标段（包）编号'"
        :disabled="isCodeDisabled"
      />
    </el-form-item>

    <el-dialog
      title="提示"
      :visible.sync="selfFillDialogVisible"
      width="480px"
      :close-on-click-modal="false"
      center
    >
      <div style="text-align: center; line-height: 1.8; font-size: 14px; color: #606266;">
        <p>请优先从项目库中搜索并选择项目，可确保出函后顺利推送至电子招投标平台；</p>
        <p>自行填写无法保证推送成功，请知悉。</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirmSelfFill">我知道了</el-button>
        <el-button @click="selfFillDialogVisible = false">取消</el-button>
      </span>
    </el-dialog>

    <ProjectDialog
      :xtDialogFormVisible="dialogVisible"
      :mode="dialogMode"
      :dialogTitle="dialogTitle"
      :platCode="platCode"
      @projectInfo="onDialogProjectInfo"
      @changeShow="onDialogClose"
    />
  </div>
</template>

<script>
import { queryDefaultDataDictionary } from '@/api/comm'
import ProjectDialog from './dialog/projectdialog'

export default {
  name: 'ProjectInfoFields',
  props: {
    form: {
      type: Object,
      required: true,
    },
    showProjectSource: {
      type: Boolean,
      default: true,
    },
    showXt: {
      type: Boolean,
      default: true,
    },
    labelProjectName: {
      type: String,
      default: '',
    },
    labelProjectCode: {
      type: String,
      default: '',
    },
    isCqsw: {
      type: Boolean,
      default: false,
    },
    isHlj: {
      type: Boolean,
      default: false,
    },
    isShgz: {
      type: Boolean,
      default: false,
    },
    isBsgzw: {
      type: Boolean,
      default: false,
    },
    projectCodeDisabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      zbjOtherOptions: [],
      otherPlatformOptions: [],
      isSelfFill: false,
      selfFillDialogVisible: false,
      dialogVisible: false,
      dialogMode: 'standard',
    }
  },
  computed: {
    resolvedLabelProjectName() {
      return this.labelProjectName || (this.isCqsw ? '项目名称' : '标段名称')
    },
    resolvedLabelProjectCode() {
      return this.labelProjectCode || (this.isCqsw ? '项目编号' : '标段编号')
    },
    isNameDisabled() {
      return this.isShgz || this.isHlj
    },
    isCodeDisabled() {
      if (this.projectCodeDisabled) return true
      const f = this.form || {}
      return !!(f.projectSource && f.sourceRadio && !this.isSelfFill && f.projectSource !== '2') || this.isHlj
    },
    platCode() {
      const source = this.form.projectSource
      const radio = this.form.sourceRadio
      if (source === '1') {
        if (radio === '0') return ''
        return radio || ''
      }
      if (source === '2') return ''
      return source || ''
    },
    dialogTitle() {
      return this.dialogMode === 'xt' ? '获取邢台项目信息' : '获取项目信息'
    },
  },
  components: {
    ProjectDialog,
  },
  created() {
    if (!this.showProjectSource) {
      if (this.isBsgzw) {
        this.$set(this.form, 'projectSource', '2015')
        this.$set(this.form, 'sourceRadio', '2015')
      } else {
        this.form.projectSource = ''
        this.form.sourceRadio = ''
      }
    }
    this.loadProZoneOptions()
  },
  methods: {
    loadProZoneOptions() {
      queryDefaultDataDictionary({ commCodes: 'PLAT_CODE' }).then((resp) => {
        if (resp.data && resp.data.dicList && resp.data.dicList.length > 0) {
          const platCode = resp.data.dicList.find(item => item.code === 'PLAT_CODE')
          if (platCode && platCode.list) {
            const zbjOtherList = []
            const otherPlatformList = []

            platCode.list.forEach(item => {
              const option = { label: item.displayName || item.name, value: item.val }
              if (item.groupCode === 'zcjb') {
                zbjOtherList.push(option)
              } else if (item.groupCode === 'other') {
                otherPlatformList.push(option)
              }
            })

            this.zbjOtherOptions = zbjOtherList
            this.otherPlatformOptions = otherPlatformList
          }
        }
        this.ensureProjectSourceName()
      }).catch(() => {
        this.zbjOtherOptions = []
        this.otherPlatformOptions = []
      })
    },
    ensureProjectSourceName() {
      if (!this.form.projectSource || this.form.projectSourceName) return

      const nameMap = {
        '1': '招采进宝平台',
        '2': '其他',
      }
      const baseName = nameMap[this.form.projectSource] || this.getPlatformName(this.form.projectSource)

      if (this.form.projectSource === '1' && this.form.sourceRadio) {
        if (this.form.sourceRadio === '0') {
          this.form.projectSourceName = `${baseName}-邢台地区`
        } else if (this.platCode) {
          const option = (this.zbjOtherOptions || []).find(item => item.value === this.platCode)
          const regionName = option ? option.label : this.platCode
          this.form.projectSourceName = `${baseName}-${regionName}`
        } else {
          this.form.projectSourceName = baseName
        }
      } else {
        this.form.projectSourceName = baseName
      }
    },
    handleProjectSourceChange(e) {
      const nameMap = {
        '1': '招采进宝平台',
        '2': '其他',
      }
      const projectName = nameMap[e] || this.getPlatformName(e)
      if (e === '1') {
        if (this.showXt) {
          this.$set(this.form, 'sourceRadio', '0')
          this.$set(this.form, 'projectSourceName', `${projectName}-邢台地区`)
        } else if (this.zbjOtherOptions.length > 0) {
          const firstOption = this.zbjOtherOptions[0]
          this.$set(this.form, 'sourceRadio', firstOption.value)
          this.$set(this.form, 'projectSourceName', `${projectName}-${firstOption.label}`)
        }
      } else if (e === '2') {
        this.$set(this.form, 'sourceRadio', '1')
        this.$set(this.form, 'projectSourceName', projectName)
      } else {
        this.$set(this.form, 'sourceRadio', e)
        this.$set(this.form, 'projectSourceName', projectName)
      }
      this.isSelfFill = false
      this.clearBidFields()
      this.$emit('sourceChange', this.form)
    },
    handleSourceRadioChange(value) {
      const baseName = '招采进宝平台'
      if (value === '0') {
        this.$set(this.form, 'sourceRadio', '0')
        this.$set(this.form, 'projectSourceName', `${baseName}-邢台地区`)
      } else {
        const option = (this.zbjOtherOptions || []).find(item => item.value === value)
        const regionName = option ? option.label : value
        this.$set(this.form, 'projectSourceName', `${baseName}-${regionName}`)
      }
      this.isSelfFill = false
      this.clearBidFields()
      this.$emit('sourceChange', this.form)
    },
    clearBidFields() {
      this.$set(this.form, 'projectName', '')
      this.$set(this.form, 'projectCode', '')
      this.$set(this.form, 'openingDate', null)
      this.$set(this.form, 'tenderCompanyName', '')
      this.$set(this.form, 'agentName', '')
      this.$set(this.form, 'apiId', '')
      this.$set(this.form, 'apiName', '')

    },
    getPlatformName(value) {
      const allOptions = [...(this.otherPlatformOptions || []), ...(this.zbjOtherOptions || [])]
      const option = allOptions.find(item => item.value === value)
      return option ? option.label : value
    },
    handleSelfFill() {
      if (this.isSelfFill) {
        return
      }
      this.selfFillDialogVisible = true
    },
    confirmSelfFill() {
      this.selfFillDialogVisible = false
      this.isSelfFill = true
      this.$set(this.form, 'projectName', '')
      this.$set(this.form, 'projectCode', '')
      this.$emit('selfFillConfirm', this.form)
    },
    handleSearchProject() {
      this.isSelfFill = false
      this.$set(this.form, 'projectName', '')
      this.$set(this.form, 'projectCode', '')
      this.openDialog('standard')
    },
    onSearchStandard() {
      this.openDialog('standard')
    },
    onSearchXt() {
      this.openDialog('xt')
    },
    openDialog(mode) {
      this.dialogMode = mode
      this.dialogVisible = true
    },
    onDialogProjectInfo(data) {
      this.setProjectInfo(data)
      this.$emit('projectInfoSelected', data)
    },
    onDialogClose(data) {
      if (data === 'false') {
        this.dialogVisible = false
      } else {
        this.dialogVisible = true
      }
    },
    setProjectInfo(data) {
      if (data.bidCode !== undefined) {
        this.$set(this.form, 'projectCodes', data.bidCode)
      }
      if (data.bidName !== undefined) {
        this.$set(this.form, 'projectName', data.bidName)
      }
      if (data.packageCode !== undefined) {
        this.$set(this.form, 'projectCode', data.packageCode)
      }
      if (data.packageName !== undefined) {
        this.$set(this.form, 'projectName', data.packageName)
      }
      if (data.bidCode !== undefined && data.packageCode !== undefined) {
        this.$set(this.form, 'projectCode', data.packageCode)
      }
      if (data.bidOpenDate) {
        const arr1 = data.bidOpenDate.split(' ')
        const sdate = arr1[0].split('-')
        const time = arr1[1].split(':')
        const date = new Date(sdate[0], sdate[1] - 1, sdate[2], time[0], time[1], time[2])
        this.$set(this.form, 'openingDate', date)
      }
      if (data.tendererName !== undefined) {
        this.$set(this.form, 'tenderCompanyName', data.tendererName)
      }
      if (data.tenderAgencyName !== undefined) {
        this.$set(this.form, 'agentName', data.tenderAgencyName)
      }
      if (data.guaranteeAmount !== undefined) {
        this.$set(this.form, 'guaranteeAmount', data.guaranteeAmount / 10000)
      }
      if (data.packageId !== undefined) {
        this.$set(this.form, 'packageId', data.packageId)
      }
      this.isSelfFill = false
    },
    resetSelfFillFields() {
      this.isSelfFill = false
      this.$set(this.form, 'projectName', '')
      this.$set(this.form, 'projectCode', '')
    },
  },
}
</script>